import { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../Components/Admin/ProtectedRoute';

const PhoneExpenseLayout = lazy(() => import('./PhoneExpenseLayout'));
const PhoneInvoiceListPage = lazy(() => import('./pages/PhoneInvoiceListPage'));
const PhoneExpenseStatsPage = lazy(() => import('./pages/PhoneExpenseStatsPage'));
const PhoneExpenseReportsPage = lazy(() => import('./pages/PhoneExpenseReportsPage'));
const PhoneInvoiceUploadPage = lazy(() => import('./pages/PhoneInvoiceUploadPage'));
const PhoneInvoiceDetailPage = lazy(() => import('./pages/PhoneInvoiceDetailPage'));
const PhoneLineDirectoryPage = lazy(() => import('./pages/PhoneLineDirectoryPage'));
const PhoneBillingAccountDirectoryPage = lazy(() => import('./pages/PhoneBillingAccountDirectoryPage'));
const PhoneBillingAccountDetailPage = lazy(() => import('./pages/PhoneBillingAccountDetailPage'));
const PhoneExpenseStatusSettings = lazy(() => import('./pages/PhoneExpenseStatusSettings'));
const PhoneExpenseStatusTransitionSettings = lazy(() => import('./pages/PhoneExpenseStatusTransitionSettings'));
const PhoneExpenseSettings = lazy(() => import('./pages/PhoneExpenseSettings'));

const PhoneExpensesRouters = (
  <Route
    path="/phone-expenses"
    element={
      <ProtectedRoute minRole="USER" appSlug="phone_expenses">
        <PhoneExpenseLayout />
      </ProtectedRoute>
    }
  >
    <Route index element={<PhoneInvoiceListPage />} />
    <Route path="stats" element={<PhoneExpenseStatsPage />} />
    <Route path="reports" element={<PhoneExpenseReportsPage />} />
    <Route path="upload" element={<PhoneInvoiceUploadPage />} />
    <Route path="lines" element={<PhoneLineDirectoryPage />} />
    <Route path="accounts" element={<PhoneBillingAccountDirectoryPage />} />
    <Route path="accounts/:accountId" element={<PhoneBillingAccountDetailPage />} />
    <Route path="settings/permissions" element={<PhoneExpenseSettings />} />
    <Route path="settings/statuses" element={<PhoneExpenseStatusSettings />} />
    <Route path="settings/status-transitions" element={<PhoneExpenseStatusTransitionSettings />} />
    <Route path=":id" element={<PhoneInvoiceDetailPage />} />
  </Route>
);

export default PhoneExpensesRouters;
